/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type GetPawningContractResponse = {
    pawningContractId?: string;
    contractNo?: string;
    sequence?: number;
    pawnedAt?: string;
    customerFirstName?: string;
    customerLastName?: string;
    customerPhoneNo?: string;
    machineBrand?: string;
    machineModel?: string;
    machineColor?: string;
    machineSerialNumber?: string;
    machineImei?: string;
    appointmentDate?: string;
    appointmentAmount?: number;
    disbursementAmount?: number;
    accumulateCapitalPaid?: number;
    accumulateInterestPaid?: number;
    accumulateFineAmountPaid?: number;
    dueAmount?: number;
    pawningStatus?: GetPawningContractResponse.pawningStatus;
    dueDate?: string;
    isActive?: boolean;
    invoiceId?: string;
};
export namespace GetPawningContractResponse {
    export enum pawningStatus {
        ONGOING = 'ONGOING',
        REDEEMED = 'REDEEMED',
        FORECLOSURE = 'FORECLOSURE',
    }
}

